// extracted by mini-css-extract-plugin
export default {"subTitle":"Lh09YqBJAM"};